import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const column1 = [
    { label: 'How It Works', to: '/how-it-works' },
    { label: 'About Us', to: '/about' },
    { label: 'Contact', to: '/contact' },
    { label: 'Start Donating', to: '/donate' },
  ];

  const column2 = [
    { label: 'Subscriber Dashboard', to: '/dashboard' },
    { label: 'Log In', to: '/login' },
    { label: 'Sign Up', to: '/signup' },
    { label: 'FAQ', to: '/how-it-works' },
  ];

  const column3 = [
    { label: 'Privacy Policy', to: '/privacy' },
    { label: 'Terms of Service', to: '/terms' },
    { label: 'Cookie Policy', to: '/privacy' },
    { label: 'Accessibility', to: '/accessibility' },
  ];

  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-18">
        {/* Top Navigation Columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-14">
          {/* Column 1 */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              Program
            </h4>
            <div className="w-8 h-px bg-accent-500 mb-4"></div>
            <ul className="flex flex-col gap-2.5">
              {column1.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 2 */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              Account
            </h4>
            <div className="w-8 h-px bg-accent-500 mb-4"></div>
            <ul className="flex flex-col gap-2.5">
              {column2.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              Legal
            </h4>
            <div className="w-8 h-px bg-accent-500 mb-4"></div>
            <ul className="flex flex-col gap-2.5">
              {column3.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 - Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-anchor-line text-base text-background-50"></i>
              </div>
              <span className="text-base font-semibold font-heading">
                clearbeaches.org
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              {t('footer.tagline')}
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background-700/40 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="text-2xl md:text-3xl font-bold font-heading text-background-50">
              clearbeaches.org
            </span>
            <span className="text-sm text-background-400">&mdash;</span>
            <span className="text-xs text-background-500">
              Cleaner beaches, one kit at a time.
            </span>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4">
            <span className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} clearbeaches.org. {t('footer.rights')}
            </span>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700/30 hover:bg-background-600/40 transition-colors cursor-pointer" aria-label="Twitter" rel="nofollow">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700/30 hover:bg-background-600/40 transition-colors cursor-pointer" aria-label="Instagram" rel="nofollow">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700/30 hover:bg-background-600/40 transition-colors cursor-pointer" aria-label="Facebook" rel="nofollow">
                <i className="ri-facebook-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}